import type { Ctx } from "./pixel";
import { MED_IMAGES, type MedImageId } from "./med-images";

export { MED_IMAGES, type MedImageId } from "./med-images";

const cache = new Map<MedImageId, HTMLImageElement>();

/** The pixelated photo for `id`, loading it on first use (null until it has loaded). */
export function medImage(id: MedImageId): HTMLImageElement | null {
  let img = cache.get(id);
  if (!img) {
    img = new Image();
    img.src = `/med/${id}.png`;
    cache.set(id, img);
  }
  return img.complete && img.naturalWidth ? img : null;
}

/** Where a photo sits on the 192×108 close-up: native pixels, centred. */
export interface Placement {
  x: number;
  y: number;
  w: number;
  h: number;
}

export function placement(id: MedImageId, cw = 192, ch = 108): Placement {
  const m = MED_IMAGES[id];
  return { x: Math.floor((cw - m.w) / 2), y: Math.floor((ch - m.h) / 2), w: m.w, h: m.h };
}

/** Black backdrop and the photo; returns its placement for overlays and hotspots. */
export function drawMed(c: Ctx, id: MedImageId): Placement {
  const p = placement(id);
  c.fillStyle = "#000";
  c.fillRect(0, 0, 192, 108);
  const img = medImage(id);
  if (img) c.drawImage(img, p.x, p.y);
  return p;
}
